// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe-container[data-v-0648e842] {\n  position: relative;\n  overflow: hidden;\n  padding-top: 50%;\n}\n.iframe-container iframe[data-v-0648e842] {\n  position: absolute;\n  top: 0;\n  border: 0;\n  height: 100%;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
